import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const RootEventSinkToken = new InjectionToken<RootEventSink>('RootEventSink');

// todo: rename to RootEventBus instead ??
export interface RootEventSink {
  fireEvent<TData>(
    eventName: string,
    data: TData,
  ): void;

  on<TData = never>(
    eventName: string,
  ): Observable<TData>;

  once<TData = never>(
    eventName: string,
  ): Observable<TData>;

  // look at notes for {@link Bridge#canHandleEvents}
  readonly canHandleEvents: boolean;
}


export const GenericEventSinkToken = new InjectionToken<GenericEventSink>('GenericEventSink');

// todo: rename to GenericEventBus instead ??
export interface GenericEventSink {
  fireEvent<TData>(
    eventName: string,
    data: TData,
  ): void;

  fireEventToParent<TData>(
    eventName: string,
    data: TData,
  ): void;

  on<TData = never>(
    eventName: string,
  ): Observable<TData>;

  onParent<TData = never>(
    eventName: string,
  ): Observable<TData>;

  onAndParent<TData = never>(
    eventName: string,
  ): Observable<TData>;

  once<TData = never>(
    eventName: string,
  ): Observable<TData>;

  onceParent<TData = never>(
    eventName: string,
  ): Observable<TData>;

  onceAndParent<TData = never>(
    eventName: string,
  ): Observable<TData>;
}
